import React from 'react';
import Layout from '../../components/layout/Layout';
import { Tabs, Tab, Box, Typography } from '@mui/material';
import Loading from '../../components/customHelpers/Loading';
import Order from '../../actions/order';
import Notify from '../../components/customHelpers/Notify';
import Staff from '../../actions/staff';
import Product from '../../actions/product';
import Customer from '../../actions/customer';
import CustomerChart from '../../components/forms/CustomerChart'; 
import CustomerCountChart from '../../components/forms/CustomerCountChart'; // Import the new component
import { isAuth } from '../../actions/auth';
import { useHistory } from "react-router-dom";

const Dashboard = () => {

  const { viewAllOrders } = Order();
  const { NotifyMessage, notify, setNotify } = Notify();
  const [customers, setCustomers] = React.useState([]); 
  const [orders, setOrders] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [tabValue, setTabValue] = React.useState(0);
  const { totalStaff } = Staff();
  const { viewTotalProducts } = Product();
  const { viewTotalCustomers,viewAllCustomers } = Customer();
  const [staffNum, setStaffNum] = React.useState(0);
  const [customer, setCustomer] = React.useState(0);
  const [products, setProducts] = React.useState(0);
  const history = useHistory();

  React.useEffect(() => {
if(isAuth()?.role === "superadmin") {
  history.push("/admin");
}
    fetchOrders();
    getAllCustomers()
    totalStaff().then((data) => {
      setStaffNum(data.result);
    });
    viewTotalCustomers().then((data) => {
      setCustomer(data.result);
    });
    viewTotalProducts().then((data) => {
      setProducts(data.result);
    });
  }, []);

  const fetchOrders = () => {
    setLoading(true);
    viewAllOrders().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: 'error',
        });
      } else {
        setOrders(data.orders);
      }
      setLoading(false);
    });
  };
  const getAllCustomers = () => {
    setLoading( true );
    viewAllCustomers().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
        setLoading( false );

      } else if (data.customers) {
     setCustomers(data.customers)
      }
    });
  };

  const filterOrdersByDate = (period) => {
    const now = new Date();
    const startDate = new Date();

    switch (period) {
      case 'week':
        startDate.setDate(now.getDate() - 7);
        break;
      case 'month':
        startDate.setMonth(now.getMonth() - 1);
        break;
      case 'year':
        startDate.setFullYear(now.getFullYear() - 1);
        break;
      default:
        return [];
    }

    return orders?.filter(order => new Date(order.createdAt) >= startDate);
  };

  const groupOrdersByCustomer = (ordersList) => {
    const customerOrders = {};

    ordersList?.forEach(order => {
      const customerId = order?.customer?.id;
      const customerName = order?.customer?.fullName;
      const orderTotal = parseFloat(order.totalPrice);

      if (!customerOrders[customerId]) {
        customerOrders[customerId] = { total: 0, fullName: customerName };
      }

      customerOrders[customerId].total += orderTotal;
    });

    return Object.entries(customerOrders)
      .map(([id, data]) => ({ id, fullName: data.fullName, total: data.total }))
      .sort((a, b) => b.total - a.total)
      .slice(0, 5); // Top 5 customers
  };

  const top5CustomersWeek = groupOrdersByCustomer(filterOrdersByDate('week'));
  const top5CustomersMonth = groupOrdersByCustomer(filterOrdersByDate('month'));
  const top5CustomersYear = groupOrdersByCustomer(filterOrdersByDate('year'));

  // Tab change handler
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const groupCustomersByDay = (customersList) => {
    const dailyData = Array(31).fill(0);
  
    customersList?.forEach((customer) => {
      const createdAt = new Date(customer.createdAt);
      const day = createdAt.getDate() - 1;
      dailyData[day] += 1; 
    });
  
    return dailyData.map((count, index) => ({
      day: index + 1,
      count,
    }));
  };
  
  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June', 
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  
  const groupCustomersByMonth = (customersList) => {
    const monthlyData = Array(12).fill(0); // Initialize array for 12 months
  
    customersList?.forEach((customer) => {
      const createdAt = new Date(customer.createdAt);
      const month = createdAt.getMonth(); // Get the month (0-11)
      monthlyData[month] += 1; // Increment customer count for the respective month
    });
  
    return monthlyData.map((count, index) => ({
      month: monthNames[index], // Convert number to month name
      count,
    }));
  };
  const groupCustomersByYear = (customersList) => {
    const yearlyData = {};
  
    customersList?.forEach((customer) => {
      const createdAt = new Date(customer.createdAt);
      const year = createdAt.getFullYear(); // Get the year
  
      // Initialize if year is not present
      if (!yearlyData[year]) {
        yearlyData[year] = 0;
      }
  
      yearlyData[year] += 1;
    });
  
    return Object.keys(yearlyData).map((year) => ({
      year: year,
      count: yearlyData[year],
    }));
  };
  
  const customerCountDay = groupCustomersByDay(customers);
  const customerCountMonth = groupCustomersByMonth(customers);
  const customerCountYear = groupCustomersByYear(customers);
  

  return (
    <Layout>
      <div className="card">
        <div className="container">
          <div className="our-team">
            <div className="picture">
              <i className="bx bx-category picture" />
            </div>
            <div className="team-content">
              <h4 className="name">{products}</h4>
              <h3 className="title">Products</h3>
            </div>
          </div>
          <div className="our-team">
            <div className="picture">
              <i className="bx bx-user picture" />
            </div>
            <div className="team-content">
              <h4 className="name">{staffNum}</h4>
              <h3 className="title">Staffs</h3>
            </div>
          </div>
          <div className="our-team">
            <div className="picture">
              <i className="bx bx-user picture" />
            </div>
            <div className="team-content">
              <h4 className="name">{customer}</h4>
              <h3 className="title">Customers</h3>
            </div>
          </div>
        </div>
      </div>

      <Box sx={{ width: '100%' }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="customer tabs">
          <Tab label="This Week" />
          <Tab label="This Month" />
          <Tab label="This Year" />
        </Tabs>

        <Box sx={{ p: 3 }}>
          {loading ? (
            <Loading />
          ) : (
            <>
              {tabValue === 0 && (
                <>
                <CustomerChart title="Top 5 Customers Highest Order This Week" data={top5CustomersWeek} />
                <CustomerCountChart
          title="Customer Count (Daily)"
          data={customerCountDay}
          xAxisKey="day"
          xLabel="Days"
        />                </>

              )}
              {tabValue === 1 && (
                <>
                <CustomerChart title="Top 5 Customers Highest Order This Month" data={top5CustomersMonth} />
                <CustomerCountChart
          title="Customer Count (Monthly)"
          data={customerCountMonth}
          xAxisKey="month"
          xLabel="Months"
        />
                </>
              )}
              {tabValue === 2 && (
                <>
                <CustomerChart title="Top 5 Customers Highest Order This Year" data={top5CustomersYear} />
                <CustomerCountChart
                title="Customer Count (Yearly)"
                data={customerCountYear}
                xAxisKey="year"
                xLabel="Years"
              />
              </>
              )}
            </>
          )}
        </Box>
      </Box>
    </Layout>
  );
};

export default Dashboard;
